<article>
  <h1 mat-dialog-title class="header-text" translate>PLANS.CONFIRM_CHANGE</h1>

  <mat-dialog-content>

    <div class="plans-table-wrapper">
      <cc-plan-brief-table
        planState="CURRENT_PLAN"
        [billingPeriod]="currentSubscription.interval"
        [numberOfUsers]="currentSubscription.quantity"
        [planName]="currentSubscription.planName"
        [pricePerUser]="priceInDollar(currentSubscription.planPriceCents)"
      ></cc-plan-brief-table>

      <cc-plan-brief-table
        planState="NEW_PLAN"
        [billingPeriod]="data.newPlan.interval"
        [numberOfUsers]="usersNumber(data.numberOfUsers, data.newPlan.usersIncluded)"
        [planName]="data.newPlan.name"
        [pricePerUser]="priceInDollar(newPlanPrice())"
      ></cc-plan-brief-table>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button color="info-full" [mat-dialog-close]="false">{{'CANCEL' | translate}}</button>
    <button mat-raised-button color="primary-full" [mat-dialog-close]="true">{{'CONFIRM' | translate}}</button>
  </mat-dialog-actions>
</article>
